import moment from 'moment'

export function fmtTime(time, fmt) {
  if (!time) return 'No time'

  return moment(time).format(fmt || 'MM/DD HH:mm:ss')
}
